namespace Areas {
    "use strict";

    export function gotoContract(id: string) {
        gotoSelected("ContractGrid", "/Contract/GeneralInfo/View/");
    }


}